import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	headers: any = {
		'Content-Type': 'application/json',
		// reportProgress: true
	};

	constructor(
		private http: HttpClient,
		private gfService: GlobalFunctionService,
		private appInit: AppInitializerService
	) { }

	login(params: any = {}, headers: any = {}): Observable<any> {
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + 'authentication/login';
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			withCredentials: true
		};
		// withCredentials: true
		return this.http.post(api, params, options);
	}

	logout(params: any = {}, headers: any = {}, token): Observable<any> {
		if (!token) {
			token = this.gfService.getCookie('token');
		}
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + 'authentication/logout';
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	sendOTP(params: any = {}, headers: any = {}): Observable<any> {
		headers.cancelable = 'N';
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + 'authentication/login';
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			withCredentials: true
		};
		return this.http.post(api, params, options);
	}

	sessionUser(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers.cancelable = 'N';
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		const api =
			this.appInit.configuration.API_URL +
			'' +
			this.appInit.configuration.API_PREFIX +
			`authentication/usersessiondetails`;
		return this.http.get(api, options);
	}

	register(params: any = {}, headers: any = {}): Observable<any> {
		headers.cancelable = 'N';
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + 'user/invite/register';
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			withCredentials: true
		};
		return this.http.post(api, params, options);
	}

	verifyInviteUser(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers.cancelable = 'N';
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		const api =
			this.appInit.configuration.API_URL +
			'' +
			this.appInit.configuration.API_PREFIX +
			`user/invite/verify`;
		return this.http.get(api, options);
	}

	reportInviteUser(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + 'user/invite/report';
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	getRolePermission(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers.cancelable = 'N';
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `permission/rolepermission`;
		return this.http.get(api, options);
	}

	reportOtp(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + 'authentication/otp/report';
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	submitDomain(params: any = {}, headers: any = {}): Observable<any> {
		headers.cancelable = 'N';
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + 'authentication/login';
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			withCredentials: true
		};
		return this.http.post(api, params, options);
	}
}
